import { render } from "./company-panel-placeholder.vue?vue&type=template&id=e3240d4e&scoped=true&ts=true"
import script from "./company-panel-placeholder.vue?vue&type=script&lang=ts"
export * from "./company-panel-placeholder.vue?vue&type=script&lang=ts"

import "./company-panel-placeholder.vue?vue&type=style&index=0&id=e3240d4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3240d4e"]])

export default __exports__